import styled, { keyframes } from 'styled-components';

const rotateAnimation = keyframes`
0% {
  filter: blur(10);
}
100% {
  transform : rotate(100deg)
}
`;

export const Container = styled.div`
  display: flex;

  transition: opacity 0.2s;
  font-weight: bold;
  margin: auto;
  justify-content: center;

  &:hover {
    opacity: 0.9;
  }

  > div {
    padding: 5px;
    display: flex;
    flex-direction: column ;
    width: 70px;
    height: 70px;
    border-radius: 10px;
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.3);
    justify-content: center;
    align-items: center;
    background: #fff;
    margin: 5px;
     
    > h3 {
      color: #134842 !important;
      font-size: 28px;
      margin-bottom: 0px;
      width: 100%;
      text-align: center !important;
    }

    > p {
      color: #134842 !important;
      font-size: 12px;
      width: 100%;
      text-align: center  !important;
    }
  }

  > p {
    font-size: 32px;
    margin-top: 0px;
    svg {
      animation: ${rotateAnimation} 1s infinite;
    }
  }
`;
